import React from 'react'
import { Text, TextProps } from '@workwhile/ui'
import { replaceAliases } from './utils/aliased_terms'

const Highlight = ({
  text = '',
  match,
  ...props
}: { text: string; match: string } & TextProps) => {
  // Escape HTML entities to prevent angle brackets from being interpreted as HTML tags
  function escapeHtml(text: string): string {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
  }

  // Don't highlight until at least 2 characters
  if (text?.length < 2 || match?.length < 2) {
    return (
      <Text as="span" {...props}>
        {text}
      </Text>
    )
  }

  function highlightTerms(text, term) {
    if (!term) {
      return text
    }
    const normalizedTerm = term?.replace(/[-_ ]/g, '\\s*')
    const regex = new RegExp(`(${normalizedTerm})`, 'gi')
    return text.replace(
      regex,
      '<span style="background-color: lemonChiffon;">$1</span>'
    )
  }

  // Escape HTML first, then apply highlighting
  const escapedText = escapeHtml(text)
  let result = highlightTerms(escapedText, match)
  result = highlightTerms(result, replaceAliases(match))

  return (
    <Text as="span" {...props} dangerouslySetInnerHTML={{ __html: result }} />
  )
}

export default Highlight
